import { render, staticRenderFns } from "./demo-pay-method.vue?vue&type=template&id=69c2bd56"
import script from "./demo-pay-method.vue?vue&type=script&lang=js"
export * from "./demo-pay-method.vue?vue&type=script&lang=js"
import style0 from "./demo-pay-method.vue?vue&type=style&index=0&id=69c2bd56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports